export const identifyDiscountBannerType = (isUserHaveAutoPay, isUserHavePaperlessBilling, isACHOrDebitEnrolled) => {
  
  switch (true) {
    case isUserHaveAutoPay && isUserHavePaperlessBilling && isACHOrDebitEnrolled:
      return "discountEligible"

    case isUserHaveAutoPay && isACHOrDebitEnrolled:
      return "enrollForPaperlessBilling"

    case isUserHavePaperlessBilling:
      return "enrollForAutopay"

    default:
      return "notEligibleForDiscount"
  }
}

export const PPFDiscountApplied = (subPlanDetails) => {
 return subPlanDetails?.standardPlans?.some((plan) => {
    return plan?.activetoDiscountsSet?.some((discountItem) => {      
      return (        
        discountItem?.Actiontype?.toUpperCase().includes("ADD") &&
        discountItem?.Disccode?.toUpperCase().includes("APWPPLDISC")
      );
    });
  }) || false;
}
export const PPFWifiDiscountApplied = (subPlanDetails) => {
 return subPlanDetails?.standardPlans?.some((plan) => {
    return plan?.activetoDiscountsSet?.some((discountItem) => {      
      return (        
       (discountItem?.Actiontype?.toUpperCase().includes("ADD") &&
       (discountItem?.Disccode?.toUpperCase().includes("HOLEXTDISC") ||
        discountItem?.Disccode?.toUpperCase().includes("WFEXTRET5")))
      );
    });
  }) || false;
}
//To retrive plan speed from plan name
export const getInternetSpeed = (str) => {
  const match = str?.trim()?.match(/(\S+\s+\S+)\s*$/);
  return match ? match[1] : str?.trim();
}